import { combineReducers } from 'redux';

// Front
import Layout from './layout/reducer';

// Authentication Module
import Login from './auth/login/reducer';
import Forget from './auth/forgetpwd/reducer';

import User from "./user/reducer";
import Role from "./role/reducer";
import Support from "./support/reducer";
import Profile from "./profile/reducer";
import Customer from "./customers/reducer";
import General from "./general/reducer";
import Dashboard from './dashboard/reducer';
import Inventory from './inventory/reducer';
import Voucher from './voucher/reducer';
import Product from './product/reducer';
import Report from './report/reducer';
import Category from './category/reducer';
import Schools from './school/reducer';
import Manufacturer from './manufacturer/reducer';
import Model from './model/reducer';
import ServiceType from './servicetype/reducer';
import Promocode from './promoCode/reducer';
import Shipping from './shipping/reducer';
import ShippingRate from './shippingrate/reducer';
import Service from './service/reducer';
import Setting from './setting/reducer';
import Permission from './permission/reducer';
import Configuration from './configuration/reducer';
import Payment from './payment/reducer';
import Review from './review/reducer';
import Order from './order/reducer';
import Banner from './banner/reducer';

const rootReducer = combineReducers({

    // public
    Layout,

    // Authentication
    Login,
    Forget,
    General,
    Payment,
    Permission,
    // setting
    Setting,
    Promocode,
    Customer,
    User,
    Profile,
    Product,
    Role,
    Support,
    Dashboard,
    Inventory,
    Report,
    Category,
    Configuration,
    Manufacturer,
    Voucher,
    Model,
    Service,
    ServiceType,
    Shipping,
    ShippingRate,
    Review,
    Order,
    Banner,
    Schools
});

export default rootReducer;